"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ReferenceArrayInputController_1 = __importDefault(require("./ReferenceArrayInputController"));

exports.ReferenceArrayInputController = ReferenceArrayInputController_1.default;

var ReferenceInputController_1 = __importDefault(require("./ReferenceInputController"));

exports.ReferenceInputController = ReferenceInputController_1.default;